
const newModel = () => {
    return {
        baocaoKehoachvonId: null,
        sttBaocao: null,
        ten: null,
        tongmucDautu: null,
        vonNamtruocChuyensang: null,
        vonphankhaiTrongnam: null,
        tinhhinhTrienkhai: null,
        giaiNgan: null,
        uocLuyke: null,
        uocnamtruocChuyensang: null,
        uocTrongnam: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        boldTen: null,
        nguonvonDautuChaStt: null,
        nguonvonDautuChaId: null,
        nguonvonDautuStt: null,
        nguonvonDautuId: null,
        duanDautuId: null,
        duanStt: null,
    }
}


const fromJson = (item) => {
    return {
        baocaoKehoachvonId: item.baocaoKehoachvonId,
        sttBaocao: item.sttBaocao,
        ten: item.ten,
        tongmucDautu: item.tongmucDautu,
        vonNamtruocChuyensang: item.vonNamtruocChuyensang,
        vonphankhaiTrongnam: item.vonphankhaiTrongnam,
        tinhhinhTrienkhai: item.tinhhinhTrienkhai,
        giaiNgan: item.giaiNgan,
        uocLuyke: item.uocLuyke,
        uocnamtruocChuyensang: item.uocnamtruocChuyensang,
        uocTrongnam: item.uocTrongnam,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
        boldTen: item.boldTen,
        nguonvonDautuChaStt: item.nguonvonDautuChaStt,
        nguonvonDautuChaId: item.nguonvonDautuChaId,
        nguonvonDautuStt: item.nguonvonDautuStt,
        nguonvonDautuId: item.nguonvonDautuId,
        duanDautuId: item.duanDautuId,
        duanStt: item.duanStt,
    }
}


export const baocaoKehoachvonChitietModel = {
    newModel,
    fromJson,

}


